import { Utilities } from "@tylertech/shared-module";
import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
    selector: "metadata-html",
    templateUrl: "./metadataHtml.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MetadataHtmlComponent
{
    @Input()
        model: string;

    get value(): string
    {
        return !Utilities.IsNullOrUndefinedOrEmpty(this.model) ? this.model : "";
    }
}
